import styled from '@emotion/styled';
import { formattingGroupSpacing } from '../common/viz-settings-common.styles';
import { useDiscoverTheme } from '../../../common/emotion/theme';

export const StyledColorSettings = styled.div`
  ${formattingGroupSpacing}
`;

export const useAddColorButtonSx = () => {
  const {
    colors: { RegularFontWeight, ActiveLinkText, CorvanaLightText },
  } = useDiscoverTheme();

  return {
    '&.MuiButtonBase-root': {
      p: 0,
      fontSize: '14px',
      fontWeight: RegularFontWeight,
      color: `${ActiveLinkText} !important`,
      ':hover': {
        textDecoration: 'none',
      },
    },
    '&.Mui-disabled[disabled]': {
      backgroundColor: 'transparent',
      color: `${CorvanaLightText} !important`,
    },
  };
};
